import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=e60b61e8"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"
import style0 from "./slide.vue?vue&type=style&index=0&id=e60b61e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports